import { create } from 'zustand'
import { LoginFormStoreType } from './storeTypes'

const useLoginFormStore = create<LoginFormStoreType.State>((set) => {
	return {
		user: undefined as any,
		isSubmitting: false,
		formErrors: {},

		/** Установщик новых значений корневого объекта. */
		updateStore(obj) {
			return set((state) => {
				return obj
			})
		},
	}
})

export default useLoginFormStore
